import {FeedEntityType, GroupCelebration, Poll, Recognition, RecognitionFeedComment} from "@irati/types"
import {get} from "lodash"
import service from "@irati-tracking/tracker"

class Tracking {
  cancelContinue = () => {
    service.trackRecognitionEvent("continue")
  }

  cancelConfirm = () => {
    service.trackRecognitionEvent("quit")
  }

  welcomeTutorial = (finished) => {
    if (finished) {
      service.trackRecognitionEvent("finished_tutorial")
    } else {
      service.trackRecognitionEvent("skipped_tutorial")
    }
  }

  commentPollAndRecognition = () => {
    service.trackRecognitionEvent("comment")
  }

  errorsComment = (response) => {
    const statusCode = get(response, "graphQLErrors[0].apiError.response.status", null)
    const data = {statusCode: `${statusCode}`}
    service.trackRecognitionEvent("comment_error", data)
  }

  clickLikeButton = (item: Recognition | Poll | RecognitionFeedComment | GroupCelebration, type: FeedEntityType) => {
    const companyValuesLength = item.companyValues?.results?.length
    service.trackRecognitionEvent("recognition_reaction", {
      entity_id: item.uuid,
      type,
      occasion: !!item.occasion,
      values: companyValuesLength || 0,
      recipients: item.receivers?.results?.length! || 0,
      has_reward: !!item.walletTransferId
    })
  }
}

export default new Tracking()
